import {
  Feedback as FeedbackComponent,
  FeedbackType
} from '@linearb/linui-common';
import { SECTIONS_TO_TRACKING_EVENTS_MAP } from './IterationSummary.consts';
import { Stack } from '@mui/material';

const Feedback = ({ section, trackingEventsHandler }) => {
  const onFeedback = (feedback: FeedbackType) => {
    if (!feedback) return;
    trackingEventsHandler.onFeedback({
      feedbackType: feedback,
      feedbackSection: SECTIONS_TO_TRACKING_EVENTS_MAP[section]
    });
  };

  const onSubmit = ({ feedback, feedbackComment }) => {
    if (!feedback) return;
    trackingEventsHandler.onFeedback({
      feedbackType: `comment-${feedback}`,
      feedbackComment,
      feedbackSection: SECTIONS_TO_TRACKING_EVENTS_MAP[section]
    });
  };

  return (
    <Stack marginTop={1}>
      <FeedbackComponent onFeedback={onFeedback} onSubmit={onSubmit} />
    </Stack>
  );
};

export default Feedback;
